import { RawSourceType, SourceType } from '../../../shared/interfaces/source';

export function SourceTypesFactory(rawSourceTypes: RawSourceType[]): SourceType[] {
  return rawSourceTypes.map(SourceTypeFactory);
}

export function SourceTypeFactory(rawSourceType: RawSourceType): SourceType {
  return {
    id: rawSourceType.type,
    sourceType: rawSourceType.type,
    displayName: rawSourceType.display_name,
    description: rawSourceType.description,
    logo: rawSourceType.logo_url,
    logoDarkMode: rawSourceType.dark_mode_logo_url || '',
    baseSourceType: rawSourceType.base_type,
    replicationTypes: (rawSourceType?.supported_replication_types || []).map(replicationType => ({
      value: replicationType.type,
      label: replicationType.display_name,
      description: replicationType.description
    })),
    properties: {
      flatFileObjectSelectEnabled: !!rawSourceType.properties?.flat_file_object_selection_enabled,
      walSlotMonitoringEnabled: !!rawSourceType.properties?.wal_slot_monitoring_enabled
    }
  };
}
